<form [formGroup]="severityImpactForm" class="grid">
  <div class="col-12">
    <h3 class="text-xl font-semibold mb-3">Incident Severity & Impact Assessment</h3>
    <p class="text-sm text-500 mb-3">
      Please provide information about the severity and impact of this incident to help with future decision-making and
      trend analysis.
    </p>
  </div>

  <label for="personalInjury" class="col-12 font-semibold mb-2">Did this incident involve personal injury?</label>
  <div class="col-12 mb-3">
    <p-select [options]="personalInjuryOptions" formControlName="personalInjuryLevel" optionLabel="label"
      optionValue="value" placeholder="Select injury level..." appendTo="body" class="w-full">
    </p-select>
  </div>

  <label for="financialImpact" class="col-12 font-semibold mb-2">Did this incident cost the organization financial
  resources?</label>
  <div class="col-12 mb-3">
    <p-select [options]="financialImpactOptions" formControlName="financialImpactLevel" optionLabel="label"
      optionValue="value" placeholder="Select financial impact level..." appendTo="body" class="w-full">
    </p-select>
  </div>

  @if (shouldShowFinancialAmount()) {
    <div class="col-12 mb-3">
      <label for="financialAmount" class="font-semibold mb-2">Please specify the dollar amount it cost PPM:</label>
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">$</span>
        <input pInputText type="number" id="financialAmount" formControlName="financialAmount" placeholder="0.00" min="0"
          step="0.01" class="w-full">
        </div>
      </div>
    }

    <label for="additionalNotes" class="col-12 font-semibold mb-2">Additional Notes (Optional)</label>
    <div class="col-12 mb-3">
      <textarea pTextarea id="additionalNotes" rows="3" class="w-full" formControlName="additionalNotes"
        placeholder="Any additional information about the incident's severity or impact...">
      </textarea>
    </div>

    <!-- Validation Messages -->
    <div class="col-12 flex flex-column gap-1 mb-3">
      @if (getFormControl('personalInjuryLevel')?.errors?.['required']) {
        <div>
          <p-message severity="error" text="Personal injury level is required"></p-message>
        </div>
      }
      @if (getFormControl('financialImpactLevel')?.errors?.['required']) {
        <div>
          <p-message severity="error" text="Financial impact level is required"></p-message>
        </div>
      }
      @if (shouldShowFinancialAmount() && getFormControl('financialAmount')?.errors?.['required']) {
        <div>
          <p-message severity="error" text="Financial amount is required for significant impact"></p-message>
        </div>
      }
    </div>

    <!-- Action Buttons -->
    <div class="col-12 flex justify-content-end gap-2">
      <p-button label="Cancel" (click)="onCancel()">
      </p-button>
      <p-button severity="success" label="{{editMode() ? 'Update Assessment' : 'Save Assessment'}}"
        [disabled]="severityImpactForm.invalid" (click)="onSubmit()" useSubmitBehavior="false">
      </p-button>
    </div>
  </form>